import { ThemeProvider } from "@/providers/ThemeProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { PermissionsProvider } from "@/providers/permissions-provider";
import { CurrencyProvider } from "@/providers/currency-provider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import App from "@/App";

export default function AppContainer() {
  return (
    <QueryProvider>
      <TooltipProvider>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
          <CurrencyProvider>
            <PermissionsProvider>
              <Toaster richColors duration={5000} closeButton />
              <App />
            </PermissionsProvider>
          </CurrencyProvider>
        </ThemeProvider>
      </TooltipProvider>
    </QueryProvider>
  );
}
